module.exports = __webpack_public_path__ + "img/banner-line-small.a47055a2.png";